import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequirePaid } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Checkout from "@/pages/Checkout";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Legal from "@/pages/Legal";
import { RequireAuth } from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();

  // Emergent OAuth callback: process session_id FIRST (synchronous check during render)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/signup" element={<Auth mode="signup" />} />
      <Route path="/checkout" element={<RequireAuth><Checkout /></RequireAuth>} />
      <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/dashboard" element={<RequirePaid><Dashboard /></RequirePaid>} />
      <Route path="/privacy" element={<Legal type="privacy" />} />
      <Route path="/terms" element={<Legal type="terms" />} />
      <Route path="/refund-policy" element={<Legal type="refund-policy" />} />
      <Route path="/success-guarantee" element={<Legal type="success-guarantee" />} />
      <Route path="/contact" element={<Legal type="contact" />} />
      <Route path="/about" element={<Legal type="about" />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
